import React, { useState, useEffect } from 'react'
import Layout from '../../layout'
import Swal from 'sweetalert2'
import Loader from '../../components/common/loader'
import Breadcrums from '../../components/common/breadcrumbs'
import { formateDate } from '../../helpers/commonFunctions'
import { GetBlockedIps, UnblockIp, GetRedisStats, GetRedisCompanySummary, GetRedisCompanyKeys, RedisFlush } from '../../services/securityService'

const SecurityPage = () => {

    const breadcrumbs = [{ title: "Dashboard", url: "/admin/dashboard" }, { title: "Security", url: "" }]
    const [activeTab, setActiveTab] = useState('blocked_ips')

    // Blocked IPs state
    const [list, setList] = useState([])
    const [loader, setLoader] = useState(true)
    const [statsUpdate, setStatusUpdate] = useState(false)

    // Redis state
    const [redisStats, setRedisStats] = useState(null)
    const [redisLoader, setRedisLoader] = useState(false)
    const [companySummary, setCompanySummary] = useState([])
    const [companySummaryLoader, setCompanySummaryLoader] = useState(false)
    const [selectedCompany, setSelectedCompany] = useState(null)
    const [companyKeys, setCompanyKeys] = useState([])
    const [companyKeysLoader, setCompanyKeysLoader] = useState(false)

    // Blocked IPs fetch
    useEffect(() => {
        if (activeTab !== 'blocked_ips') return
        setLoader(true)
        GetBlockedIps().then(data => {
            const body = data?.data
            const rows = Array.isArray(body) ? body
                : Array.isArray(body?.data) ? body.data
                : Array.isArray(body?.response?.rows) ? body.response.rows
                : Array.isArray(body?.response) ? body.response
                : []
            setList(rows)
            setLoader(false)
        }).catch(error => {
            console.log("error ====> ", error);
            setLoader(false)
        })
    }, [statsUpdate, activeTab])

    // Redis stats fetch
    useEffect(() => {
        if (activeTab !== 'redis_cache') return
        fetchRedisStats()
        fetchCompanySummary()
    }, [activeTab])

    const fetchRedisStats = () => {
        setRedisLoader(true)
        GetRedisStats().then(data => {
            setRedisStats(data?.data?.response || data?.data?.data || null)
            setRedisLoader(false)
        }).catch(error => {
            console.log("redis stats error ====> ", error)
            setRedisLoader(false)
        })
    }

    const fetchCompanySummary = () => {
        setCompanySummaryLoader(true)
        GetRedisCompanySummary().then(data => {
            const body = data?.data
            const resp = body?.response || body?.data
            let rows = []
            if (Array.isArray(resp)) {
                rows = resp
            } else if (resp && typeof resp === 'object') {
                rows = Object.entries(resp).map(([key, val]) => {
                    if (typeof val === 'object' && val !== null) return { company_register_id: key, ...val }
                    return { company_register_id: key, keyCount: val }
                })
            }
            setCompanySummary(rows)
            setCompanySummaryLoader(false)
        }).catch(error => {
            console.log("redis summary error ====> ", error)
            setCompanySummaryLoader(false)
        })
    }

    const fetchCompanyKeys = (company_register_id) => {
        setSelectedCompany(company_register_id)
        setCompanyKeysLoader(true)
        GetRedisCompanyKeys({ company_register_id }).then(data => {
            const body = data?.data
            const resp = body?.response || body?.data
            let rows = []
            if (Array.isArray(resp)) {
                rows = resp
            } else if (resp && typeof resp === 'object' && resp.keys) {
                rows = Array.isArray(resp.keys) ? resp.keys : []
            }
            setCompanyKeys(rows)
            setCompanyKeysLoader(false)
        }).catch(error => {
            console.log("redis keys error ====> ", error)
            setCompanyKeysLoader(false)
        })
    }

    const formatLabel = (key) => {
        return key.replace(/([A-Z])/g, ' $1').replace(/[_-]/g, ' ').replace(/\b\w/g, c => c.toUpperCase()).trim()
    }

    const unblockFunction = (ip) => {
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            text: `Do you want to unblock IP ${ip}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#403fad',
            cancelButtonColor: '#f1388b',
            confirmButtonText: 'Yes, unblock it!'
        }).then((result) => {
            if (result.isConfirmed) {
                const formData = new FormData()
                formData.append("ip", ip)
                UnblockIp({ ip }).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            icon: 'success',
                            title: data?.data?.message || 'IP unblocked successfully',
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                        setStatusUpdate(!statsUpdate)
                    }
                }).catch(error => {
                    console.log("unblockError ====> ", error)
                    Swal.fire({
                        customClass: 'swal-wide',
                        icon: 'error',
                        title: error?.response?.data?.message || 'Failed to unblock IP',
                        showConfirmButton: false,
                        timer: 2000,
                        toast: true,
                        position: 'top-right',
                    })
                })
            }
        })
    }

    const handleFlushRedis = () => {
        Swal.fire({
            customClass: 'swal-wide',
            title: 'Are you sure?',
            text: 'This will flush the entire Redis database!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#403fad',
            cancelButtonColor: '#f1388b',
            confirmButtonText: 'Yes, flush it!'
        }).then((result) => {
            if (result.isConfirmed) {
                RedisFlush({ confirm: "FLUSH" }).then(data => {
                    if (data.status === 200) {
                        Swal.fire({
                            customClass: 'swal-wide',
                            icon: 'success',
                            title: data?.data?.message || 'Redis flushed successfully',
                            showConfirmButton: false,
                            timer: 2000,
                            toast: true,
                            position: 'top-right',
                        })
                        fetchRedisStats()
                        fetchCompanySummary()
                        setCompanyKeys([])
                        setSelectedCompany(null)
                    }
                }).catch(error => {
                    console.log("flush error ====> ", error)
                    Swal.fire({
                        customClass: 'swal-wide',
                        icon: 'error',
                        title: error?.response?.data?.message || 'Failed to flush Redis',
                        showConfirmButton: false,
                        timer: 2000,
                        toast: true,
                        position: 'top-right',
                    })
                })
            }
        })
    }

    return (
        <Layout>
            <Breadcrums data={breadcrumbs} />
            <div className="animation_fade">
                {/* Tab Header */}
                <ul className="nav nav-tabs mb-3">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'blocked_ips' ? 'active' : ''}`}
                            onClick={() => setActiveTab('blocked_ips')}
                        >
                            Blocked IPs
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'redis_cache' ? 'active' : ''}`}
                            onClick={() => setActiveTab('redis_cache')}
                        >
                            Redis Cache
                        </button>
                    </li>
                </ul>

                {/* Blocked IPs Tab */}
                {activeTab === 'blocked_ips' && (
                    <div className="card custom-card overflow-hidden">
                        <div className="card-body">
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <h6 className="main-content-label">Blocked IPs</h6>
                            </div>
                            <div className="table-responsive">
                                <table id="example-input" className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                                    <thead>
                                        <tr>
                                            <th className="sr_head" width="10%">S.No</th>
                                            <th width="20%">IP Address</th>
                                            <th width="25%">Reason</th>
                                            <th width="20%">Blocked At</th>
                                            <th width="15%">TTL (seconds)</th>
                                            <th className='action_head' width="10%">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loader ?
                                            <tr>
                                                <td colSpan={6}><Loader /></td>
                                            </tr> : <>
                                                {list.length ? list.map((row, i) => (
                                                    <tr key={i}>
                                                        <td>{i + 1}</td>
                                                        <td>{row.ip || "N/A"}</td>
                                                        <td>{row.reason || "N/A"}</td>
                                                        <td>{row.blocked_at ? formateDate(row.blocked_at) : "N/A"}</td>
                                                        <td>{row.ttl_seconds != null ? row.ttl_seconds : "N/A"}</td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <button className="btn ripple btn-main-primary signbtn" onClick={() => unblockFunction(row.ip)}>Unblock IP</button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )) : <tr><td colSpan={6} className="text-center">No records</td></tr>}
                                            </>}
                                    </tbody>
                                </table>
                            </div>
                            <div className="" id="example1_info" role="status" aria-live="polite"><b>Total Records : {list.length || 0}</b></div>
                        </div>
                    </div>
                )}

                {/* Redis Cache Tab */}
                {activeTab === 'redis_cache' && (
                    <div>
                        {/* Redis Stats Card */}
                        <div className="card custom-card overflow-hidden mb-3">
                            <div className="card-body">
                                <div className='d-flex justify-content-between align-items-center mb-4'>
                                    <h6 className="main-content-label">Redis Stats</h6>
                                    <div>
                                        <button className="btn ripple btn-main-primary signbtn me-2" onClick={() => { fetchRedisStats(); fetchCompanySummary(); }}>Refresh</button>
                                        <button className="btn ripple btn-danger" onClick={handleFlushRedis}>Flush All</button>
                                    </div>
                                </div>
                                {redisLoader ? <Loader /> : redisStats ? (
                                    <div className="row">
                                        {Object.entries(redisStats).filter(([key]) => typeof redisStats[key] !== 'object').map(([key, value]) => (
                                            <div className="col-lg-3 col-md-6 mb-3" key={key}>
                                                <div className="card border p-3 text-center">
                                                    <h6 className="text-muted mb-1">{formatLabel(key)}</h6>
                                                    <h4>{value != null ? String(value) : 'N/A'}</h4>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : <p className="text-center text-muted">No stats available</p>}
                            </div>
                        </div>

                        {/* Company Summary Card */}
                        <div className="card custom-card overflow-hidden mb-3">
                            <div className="card-body">
                                <div className='d-flex justify-content-between align-items-center mb-4'>
                                    <h6 className="main-content-label">Company Summary</h6>
                                </div>
                                <div className="table-responsive">
                                    {(() => {
                                        const columns = companySummary.length ? Object.keys(companySummary[0]).filter(k => typeof companySummary[0][k] !== 'object') : []
                                        const idKey = columns.find(k => k.toLowerCase().includes('company') || k.toLowerCase().includes('register') || k.toLowerCase().includes('id')) || columns[0]
                                        return (
                                            <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                                                <thead>
                                                    <tr>
                                                        <th width="10%">S.No</th>
                                                        {columns.map(col => (
                                                            <th key={col}>{formatLabel(col)}</th>
                                                        ))}
                                                        <th className='action_head' width="15%">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {companySummaryLoader ?
                                                        <tr>
                                                            <td colSpan={columns.length + 2}><Loader /></td>
                                                        </tr> : <>
                                                            {companySummary.length ? companySummary.map((row, i) => (
                                                                <tr key={i}>
                                                                    <td>{i + 1}</td>
                                                                    {columns.map(col => (
                                                                        <td key={col}>{row[col] != null ? String(row[col]) : 'N/A'}</td>
                                                                    ))}
                                                                    <td>
                                                                        <button
                                                                            className="btn ripple btn-main-primary signbtn"
                                                                            onClick={() => fetchCompanyKeys(row[idKey])}
                                                                        >
                                                                            View Keys
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            )) : <tr><td colSpan={columns.length + 2} className="text-center">No records</td></tr>}
                                                        </>}
                                                </tbody>
                                            </table>
                                        )
                                    })()}
                                </div>
                                <div role="status" aria-live="polite"><b>Total Records : {companySummary.length || 0}</b></div>
                            </div>
                        </div>

                        {/* Company Keys Card */}
                        {selectedCompany && (
                            <div className="card custom-card overflow-hidden mb-3">
                                <div className="card-body">
                                    <div className='d-flex justify-content-between align-items-center mb-4'>
                                        <h6 className="main-content-label">Keys for Company: {selectedCompany}</h6>
                                        <button className="btn ripple btn-secondary" onClick={() => { setSelectedCompany(null); setCompanyKeys([]); }}>Close</button>
                                    </div>
                                    <div className="table-responsive">
                                        {(() => {
                                            const columns = companyKeys.length ? Object.keys(companyKeys[0]).filter(k => typeof companyKeys[0][k] !== 'object') : []
                                            return (
                                                <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                                                    <thead>
                                                        <tr>
                                                            <th width="10%">S.No</th>
                                                            {columns.map(col => (
                                                                <th key={col}>{formatLabel(col)}</th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {companyKeysLoader ?
                                                            <tr>
                                                                <td colSpan={columns.length + 1}><Loader /></td>
                                                            </tr> : <>
                                                                {companyKeys.length ? companyKeys.map((row, i) => (
                                                                    <tr key={i}>
                                                                        <td>{i + 1}</td>
                                                                        {columns.map(col => (
                                                                            <td key={col} style={col.toLowerCase().includes('key') || col.toLowerCase().includes('name') ? { whiteSpace: 'normal', wordBreak: 'break-all' } : {}}>
                                                                                {row[col] != null ? String(row[col]) : 'N/A'}
                                                                            </td>
                                                                        ))}
                                                                    </tr>
                                                                )) : <tr><td colSpan={columns.length + 1} className="text-center">No keys found</td></tr>}
                                                            </>}
                                                    </tbody>
                                                </table>
                                            )
                                        })()}
                                    </div>
                                    <div role="status" aria-live="polite"><b>Total Keys : {companyKeys.length || 0}</b></div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </Layout>
    );
}

export default SecurityPage
